/**
 * What the outfit gallery (DesktopMascotCard.tsx) and its sections (DayOutfitsSection.tsx, BulkOutfitsSection.tsx)
 * share: the wallpaper a picture sits on, and the clock an event handler reads. The buttons and the pressed look of a
 * toggle are the kit's (ui/Button with aria-pressed; kit.css).
 */

/** The wallpaper behind a preview or a tile: the checkerboard for transparency, or a plain light or dark desktop. */
export type Wallpaper = 'checker' | 'light' | 'dark';

export const WALLPAPER_LABELS: Record<Wallpaper, string> = { checker: 'Transparent', light: 'Light', dark: 'Dark' };

/** The class that paints a wallpaper (kit.css .ui-wall-*); anything that is not a wallpaper paints the checkerboard. */
export function wallpaperClass(wallpaper: Wallpaper | string | undefined): string {
  return wallpaper === 'light' || wallpaper === 'dark' ? `ui-wall-${wallpaper}` : 'ui-wall-checker';
}

/** The time an event handler acts at (a module-level helper, as Support.tsx reads the clock; never called while rendering). */
export const clockNow = (): number => Date.now();
